<template>
  <v-app
    id="app"
    :class="{
      [`v-application--${themeName}`]: true,
      [`v-application--3ds-mode`]: is3DSMode,
    }"
  >
    <router-view />
  </v-app>
</template>

<script>
import { getFavicon } from '@/helpers/favicon-by-brand.js';
import { appThemeFontFamily } from '@/helpers/app-theme.js';
import { getUrlParameter } from '@/helpers/url-parameter';
import { mapState } from 'vuex';
import { THEME } from './helpers/app-theme';
import { getUUID } from '@/helpers/tx-utilies';
import { WIDGET_LOG, WIDGET_EVENT } from '@/store/global';

import './polyfills/replace-all.polyfill.js';

export default {
  metaInfo: {
    title: 'Payment form',
    titleTemplate: '%s | Payment form',
  },
  data() {
    return {
      WIDGET_LOG: Object.freeze(WIDGET_LOG),
      WIDGET_EVENT: Object.freeze(WIDGET_EVENT),
    };
  },
  watch: {
    challengeListenerCnFlow(isEnable) {
      if (isEnable)
        window.addEventListener('message', this.handleMessage, { once: true });
    },
  },
  computed: {
    ...mapState({
      is3DsInProcess: ({ is3DsInProcess }) => is3DsInProcess,
      challengeListenerCnFlow: ({ challengeListenerCnFlow }) =>
        challengeListenerCnFlow,
      challengeListenerTerminalId: ({ challengeListenerTerminalId }) =>
        challengeListenerTerminalId,
    }),
    themeName() {
      return getUrlParameter('theme') || '';
    },
    is3DSMode() {
      if (!this.is3DsInProcess) return false;

      switch (this.themeName) {
        case THEME.SLOTOKING_BL:
        case THEME.TRIPPLE_SEVEN_BL:
        case THEME.TRIPPLE_SEVEN_BL_VER2:
        case THEME.JACKPOTT_RABBIT:
          return true;
        default:
          return false;
      }
    },
  },
  methods: {
    handleMessage(event) {
      if (this.challengeListenerCnFlow && event.data === 'challenge_success') {
        const terminalId = this.challengeListenerTerminalId;

        this.$store
          .dispatch('sendChallengeCnFlowStatus', {
            uuid: getUUID(),
            terminalId: this.challengeListenerTerminalId,
            payload: {},
          })
          .then((response) => {
            this.$store.dispatch('sendLog', {
              logType: this.WIDGET_LOG.INFO,
              message: 'CoinFlow challenge success sent',
              details: {
                transactionId: getUUID(),
                event: this.WIDGET_EVENT.COINFLOW_3DS_CHALLENGE,
                eventUTC: new Date().toISOString(),
                description: `Coinflow challenge success sent for terminal ${terminalId}`,
                response: {
                  status: response.status,
                },
              },
            });
          })
          .then(() => {
            this.$store.dispatch('setChallengeListenerCnFlow', false, {
              root: true,
            });

            this.$store.dispatch('setChallengeListenerTerminalId', null, {
              root: true,
            });
          })
          .then(() => {
            const element = document.getElementById('resultIframeId');
            element.innerHTML = '';
          })
          .catch((error) => {
            this.$store.dispatch('sendLog', {
              logType: this.WIDGET_LOG.ERROR,
              message: 'Coinflow challenge error',
              details: {
                transactionId: getUUID(),
                event: this.WIDGET_EVENT.COINFLOW_3DS_CHALLENGE,
                eventUTC: new Date().toISOString(),
                description: `Widget received coinflow's success challenge event but exception occurs while sending request with payload to the server for terminal ${terminalId}`,
                response: {
                  error: error.message,
                },
              },
            });
          });
      }
    },
  },
  mounted() {
    const fontFamily = appThemeFontFamily();
    if (fontFamily)
      document.getElementById('app').style.fontFamily = fontFamily;

    const fav = document.getElementById('favicon');
    fav.href = `${window.location.origin}/${getFavicon()}`;
  },
  unmounted() {
    window.removeEventListener('message', this.handleMessage);
  },
};
</script>

<style lang="scss" scoped>
html,
body,
html body .v-application {
  color: var(--v-color-base);
  background: var(--v-background-base);
}

html body .v-application--Vegas-Black {
  background: linear-gradient(151.65deg, #001b24 11.71%, #003d52 82.48%);
  font-variant-numeric: lining-nums proportional-nums;
}

html body .v-application--VegasWay-Black {
  font-variant-numeric: lining-nums proportional-nums;
}

html body .v-application--MrGoodwin-Black {
  font-variant-numeric: lining-nums proportional-nums;
  input {
    font-variant-numeric: lining-nums proportional-nums;
  }
}

html body .v-application--NLC_V3,
html body .v-application--NLC_V4 {
  background: linear-gradient(180deg, #303245, #12131c);
}

html body .v-application--3ds-mode {
  background: #c0c0cd;
}
</style>
